// Thu Mar 27 06:04:37 GMT 2025

import * as models from "../crm-web-api-models"

export enum TransactionProp {
	Auth3D = 'auth3D',
	AvailableReason = 'availableReason',
	CanceledByTransaction = 'canceledByTransaction',
	CancelsTransaction = 'cancelsTransaction',
	CcNumber = 'ccNumber',
	CreationTime = 'creationTime',
	CustomerBrandName = 'customer.brand.name',
	CustomerComplianceDataAllowDeposits = 'customer.complianceData.allowDeposits',
	CustomerId = 'customer.id',
	CustomerPersonFirstName = 'customer.person.firstName',
	CustomerPersonLastName = 'customer.person.lastName',
	CustomerPersonName = 'customer.person.name',
	DepositDate = 'depositDate',
	Description = 'description',
	Ecdd = 'ecdd',
	ExternalId = 'externalId',
	Id = 'id',
	ModificationTime = 'modificationTime',
	ModifiedBy = 'modifiedBy',
	PaymentDate = 'paymentDate',
	PermanentUser = 'permanentUser',
	ReasonCustomerReason = 'reason.customerReason',
	ReasonInternalReason = 'reason.internalReason',
	RefundedAmount = 'refundedAmount',
	RejectionReason = 'rejectionReason',
	RelatedBonus = 'relatedBonus',
	RelatedInternalTransactionId = 'relatedInternalTransactionId',
	SasReportExcluded = 'sasReportExcluded',
	Source$sourceBankAccountName = 'source$sourceBankAccount.name',
	SourceAmount = 'source.amount',
	SourceApmExternalTransactionId = 'source.apmExternalTransactionId',
	SourceCreditCardId = 'source.creditCard.id',
	SourceCurrency = 'source.currency',
	SourceDepositCountry = 'source.depositCountry',
	SourceDepositCountry$list = 'source.depositCountry$list',
	SourceError = 'source.error',
	SourceExtAccountID = 'source.extAccountID',
	SourceExternalTransactionId = 'source.externalTransactionId',
	SourceFundMethodType = 'source.fundMethodType',
	SourcePaymentMethodName = 'source.paymentMethodName',
	SourcePaymentProcessor = 'source.paymentProcessor',
	SourceSourceBankAccount = 'source.sourceBankAccount',
	SourceSourceBankAccountId = 'source.sourceBankAccount.id',
	SourceStatus = 'source.status',
	SourceTargetBankAccount = 'source.targetBankAccount',
	SourceTargetBankAccountName = 'source.targetBankAccount.name',
	SourceTraceId = 'source.traceId',
	Status = 'status',
	TargetAmount = 'target.amount',
	TargetAuthCode = 'target.authCode',
	TargetCreditCardId = 'target.creditCard.id',
	TargetCreditCardNumber = 'target.creditCard.number',
	TargetCreditCardDeposit = 'target.creditCardDeposit',
	TargetCurrency = 'target.currency',
	TargetError = 'target.error',
	TargetExtAccountID = 'target.extAccountID',
	TargetExternalTransactionDetails = 'target.externalTransactionDetails',
	TargetExternalTransactionId = 'target.externalTransactionId',
	TargetSourceBankAccountName = 'target.sourceBankAccount.name',
	TargetStatus = 'target.status',
	TargetTargetBankAccountId = 'target.targetBankAccount.id',
	TargetTargetBankAccountName = 'target.targetBankAccount.name',
	TargetCurrencyConvRate = 'targetCurrencyConvRate',
	TradingAccountId = 'tradingAccountId',
	TradingAccountId$name = 'tradingAccountId$name',
	TransactionKind = 'transactionKind',
	TransactionType = 'transactionType',
	TxSubType = 'txSubType',
	WithdrawalRequestId = 'withdrawalRequest.id',
	WithdrawalRequestRequestedAmount = 'withdrawalRequest.requestedAmount',
	WithdrawalRequestRequestedCurrency = 'withdrawalRequest.requestedCurrency'
}

export type TransactionPropAuth3D = {
	[TransactionProp.Auth3D] : boolean | null
}
export type TransactionPropAvailableReason = {
	[TransactionProp.AvailableReason] : any /* Entity */
}
export type TransactionPropCanceledByTransaction = {
	[TransactionProp.CanceledByTransaction] : number | null
}
export type TransactionPropCancelsTransaction = {
	[TransactionProp.CancelsTransaction] : number | null
}
export type TransactionPropCcNumber = {
	[TransactionProp.CcNumber] : string | null
}
export type TransactionPropCreationTime = {
	[TransactionProp.CreationTime] : number | null
}
export type TransactionPropCustomerBrandName = {
	[TransactionProp.CustomerBrandName] : string | null
}
export type TransactionPropCustomerComplianceDataAllowDeposits = {
	[TransactionProp.CustomerComplianceDataAllowDeposits] : boolean | null
}
export type TransactionPropCustomerId = {
	[TransactionProp.CustomerId] : number | null
}
export type TransactionPropCustomerPersonFirstName = {
	[TransactionProp.CustomerPersonFirstName] : string | null
}
export type TransactionPropCustomerPersonLastName = {
	[TransactionProp.CustomerPersonLastName] : string | null
}
export type TransactionPropCustomerPersonName = {
	[TransactionProp.CustomerPersonName] : string | null
}
export type TransactionPropDepositDate = {
	[TransactionProp.DepositDate] : number | null
}
export type TransactionPropDescription = {
	[TransactionProp.Description] : string | null
}
export type TransactionPropEcdd = {
	[TransactionProp.Ecdd] : boolean | null
}
export type TransactionPropExternalId = {
	[TransactionProp.ExternalId] : string | null
}
export type TransactionPropId = {
	[TransactionProp.Id] : number
}
export type TransactionPropModificationTime = {
	[TransactionProp.ModificationTime] : number | null
}
export type TransactionPropModifiedBy = {
	[TransactionProp.ModifiedBy] : models.UserDto
}
export type TransactionPropPaymentDate = {
	[TransactionProp.PaymentDate] : number | null
}
export type TransactionPropPermanentUser = {
	[TransactionProp.PermanentUser] : string | null
}
export type TransactionPropReasonCustomerReason = {
	[TransactionProp.ReasonCustomerReason] : string | null
}
export type TransactionPropReasonInternalReason = {
	[TransactionProp.ReasonInternalReason] : string | null
}
export type TransactionPropRefundedAmount = {
	[TransactionProp.RefundedAmount] : number | null
}
export type TransactionPropRejectionReason = {
	[TransactionProp.RejectionReason] : 'REJECTED_BY_COMPANY' | 'REJECTED_BY_USER' | 'BELOW_ALLOWED_MINIMUM_AMOUNT' | 'PASSED_ALLOWED_TOTAL_AMOUNT' | 'PASSED_ALLOWED_DEPOSIT_COUNT' | 'PASSED_ALLOWED_CC_DEPOSIT_COUNT' | 'CREDIT_CARD_STATUS_NOT_APPROVED' | 'PASSED_ALLOWED_TOTAL_DEPOSIT_AMOUNT_GRACE_PERIOD' | null
}
export type TransactionPropRelatedBonus = {
	[TransactionProp.RelatedBonus] : any /* Entity */
}
export type TransactionPropRelatedInternalTransactionId = {
	[TransactionProp.RelatedInternalTransactionId] : number | null
}
export type TransactionPropSasReportExcluded = {
	[TransactionProp.SasReportExcluded] : boolean | null
}
export type TransactionPropSource$sourceBankAccountName = {
	[TransactionProp.Source$sourceBankAccountName] : any /* Entity */
}
export type TransactionPropSourceAmount = {
	[TransactionProp.SourceAmount] : number | null
}
export type TransactionPropSourceApmExternalTransactionId = {
	[TransactionProp.SourceApmExternalTransactionId] : string | null
}
export type TransactionPropSourceCreditCardId = {
	[TransactionProp.SourceCreditCardId] : number | null
}
export type TransactionPropSourceCurrency = {
	[TransactionProp.SourceCurrency] : 'USD' | 'EUR' | 'GBP' | 'CAD' | 'JPY' | 'AED' | 'PLN' | 'AZN' | 'INR' | 'NZD' | 'CUP' | 'EGP' | 'LBP' | 'RMB' | 'AUD' | 'ILS' | 'RON' | 'CHF' | 'CZK' | 'DKK' | 'RUB' | 'BGN' | 'HRK' | 'CNY' | 'MXN' | 'CLP' | 'ALL' | 'NOK' | 'SEK' | 'HUF' | 'BRL' | 'ZAR' | 'HKD' | 'SGD' | 'THB' | 'TRY' | 'KRW' | 'SKK' | 'LKR' | 'COP' | 'VND' | 'CNH' | 'SAR' | 'MYR' | 'USDT' | 'LOCAL_CURRENCY' | null
}
export type TransactionPropSourceDepositCountry = {
	[TransactionProp.SourceDepositCountry] : 'NA' | 'AFGHANISTAN' | 'ÅLAND_ISLANDS' | 'ALBANIA' | 'ALGERIA' | 'AMERICAN_SAMOA' | 'ANDORRA' | 'ANGOLA' | 'ANGUILLA' | 'ANTARCTICA' | 'ANTIGUA_AND_BARBUDA' | 'ARGENTINA' | 'ARMENIA' | 'ARUBA' | 'AUSTRALIA' | 'AUSTRIA' | 'AZERBAIJAN' | 'BAHAMAS' | 'BAHRAIN' | 'BANGLADESH' | 'BARBADOS' | 'BELARUS' | 'BELGIUM' | 'BELIZE' | 'BENIN' | 'BERMUDA' | 'BHUTAN' | 'BOLIVIA' | 'BONAIRE_SINT_EUSTATIUS_AND_SABA' | 'BOSNIA_AND_HERZEGOVINA' | 'BOTSWANA' | 'BOUVET_ISLAND' | 'BRAZIL' | 'BRITISH_INDIAN_OCEAN_TERRITORY' | 'BRUNEI_DARUSSALAM' | 'BULGARIA' | 'BURKINA_FASO' | 'BURUNDI' | 'CAMBODIA' | 'CAMEROON' | 'CANADA' | 'CAPE_VERDE' | 'CAYMAN_ISLANDS' | 'CENTRAL_AFRICAN_REPUBLIC' | 'CHAD' | 'CHILE' | 'CHINA' | 'CHRISTMAS_ISLAND' | 'COCOS_ISLANDS' | 'COLOMBIA' | 'COMOROS' | 'CONGO' | 'CONGO_THE_DEMOCRATIC_REPUBLIC_OF_THE' | 'COOK_ISLANDS' | 'COSTA_RICA' | 'CROATIA' | 'CUBA' | 'CURAÇAO' | 'CYPRUS' | 'CZECH_REPUBLIC' | 'CÔTE_DIVOIRE' | 'DENMARK' | 'DJIBOUTI' | 'DOMINICA' | 'DOMINICAN_REPUBLIC' | 'EAST_TIMOR' | 'ECUADOR' | 'EGYPT' | 'EL_SALVADOR' | 'EQUATORIAL_GUINEA' | 'ERITREA' | 'ESTONIA' | 'ETHIOPIA' | 'FALKLAND_ISLANDS' | 'FAROE_ISLANDS' | 'FIJI' | 'FINLAND' | 'FRANCE' | 'FRENCH_GUIANA' | 'FRENCH_POLYNESIA' | 'FRENCH_SOUTHERN_TERRITORIES' | 'GABON' | 'GAMBIA' | 'Georgia' | 'GERMANY' | 'GHANA' | 'GIBRALTAR' | 'GREECE' | 'GREENLAND' | 'GRENADA' | 'GUADELOUPE' | 'GUAM' | 'GUATEMALA' | 'GUERNSEY' | 'GUINEA' | 'GUINEA_BISSAU' | 'GUYANA' | 'HAITI' | 'HEARD_ISLAND_AND_MCDONALD_ISLANDS' | 'HONDURAS' | 'HONG_KONG' | 'Hungary' | 'ICELAND' | 'INDIA' | 'INDONESIA' | 'IRAN' | 'IRAQ' | 'IRELAND' | 'ISLE_OF_MAN' | 'ISRAEL' | 'ITALY' | 'JAMAICA' | 'JAPAN' | 'JERSEY' | 'JORDAN' | 'KAZAKHSTAN' | 'KENYA' | 'KIRIBATI' | 'KOSOVO' | 'KOREA_DEMOCRATIC_PEOPLE_REPUBLIC_OF' | 'KOREA_REPUBLIC_OF' | 'KUWAIT' | 'KYRGYZSTAN' | 'LAO_PEOPLE_DEMOCRATIC_REPUBLIC' | 'LATVIA' | 'LEBANON' | 'LESOTHO' | 'LIBERIA' | 'LIBYAN' | 'LIECHTENSTEIN' | 'LITHUANIA' | 'LUXEMBOURG' | 'MACAO' | 'MADAGASCAR' | 'MALAWI' | 'MALAYSIA' | 'MALDIVES' | 'MALI' | 'MALTA' | 'MARSHALL_ISLANDS' | 'MARTINIQUE' | 'MAURITANIA' | 'MAURITIUS' | 'MAYOTTE' | 'MEXICO' | 'MICRONESIA' | 'MOLDOVA_REPUBLIC_OF' | 'MONACO' | 'MONGOLIA' | 'MONTENEGRO' | 'MONTSERRAT' | 'MOROCCO' | 'MOZAMBIQUE' | 'MYANMAR' | 'NAMIBIA' | 'NAURU' | 'NEPAL' | 'NETHERLANDS' | 'NETHERLANDS_ANTILLES' | 'NEW_CALEDONIA' | 'NEW_ZEALAND' | 'NICARAGUA' | 'NIGER' | 'NIGERIA' | 'NIUE' | 'NORFOLK_ISLAND' | 'NORTHERN_MARIANA_ISLANDS' | 'NORWAY' | 'OMAN' | 'PAKISTAN' | 'PALAU' | 'PALESTINIAN_TERRITORY_OCCUPIED' | 'PANAMA' | 'PAPUA_NEW_GUINEA' | 'PARAGUAY' | 'PERU' | 'PHILIPPINES' | 'PITCAIRN' | 'POLAND' | 'PORTUGAL' | 'PUERTO_RICO' | 'QATAR' | 'ROMANIA' | 'RUSSIAN_FEDERATION' | 'RWANDA' | 'RÉUNION' | 'SAINT_BARTHÉLEMY_BL' | 'SAINT_HELENA' | 'SAINT_KITTS_AND_NEVIS' | 'SAINT_LUCIA' | 'SAINT_MARTIN_FRENCH_PART' | 'SAINT_PIERRE_AND_MIQUELON' | 'SAINT_VINCENT_AND_THE_GRENADINES' | 'SAMOA' | 'SAN_MARINO' | 'SAO_TOME_AND_PRINCIPE' | 'SAUDI_ARABIA' | 'SENEGAL' | 'SERBIA' | 'SEYCHELLES' | 'SIERRA_LEONE' | 'SINGAPORE' | 'SINT_MAARTEN_DUTCH_PART' | 'SLOVAKIA' | 'SLOVENIA' | 'SOLOMON_ISLANDS' | 'SOMALIA' | 'SOUTH_AFRICA' | 'SOUTH_GEORGIA_AND_THE_SOUTH_SANDWICH_ISLANDS' | 'SOUTH_SUDAN' | 'SPAIN' | 'SRI_LANKA' | 'SUDAN' | 'SURINAME' | 'SVALBARD_AND_JAN_MAYEN' | 'SWAZILAND' | 'SWEDEN' | 'SWITZERLAND' | 'SYRIAN_ARAB_REPUBLIC' | 'TAIWAN' | 'TAJIKISTAN' | 'THAILAND' | 'THE_FORMER_YUGOSLAV_REPUBLIC_OF_MACEDONIA' | 'TOGO' | 'TOKELAU' | 'TONGA' | 'TRINIDAD_AND_TOBAGO' | 'TUNISIA' | 'TURKEY' | 'TURKMENISTAN' | 'TURKS_AND_CAICOS_ISLANDS' | 'TUVALU' | 'UGANDA' | 'UKRAINE' | 'UNITED_ARAB_EMIRATES' | 'UNITED_KINGDOM' | 'UNITED_REPUBLIC_OF_TANZANIA' | 'UNITED_STATES_MINOR_OUTLYING_ISLANDS' | 'URUGUAY' | 'USA' | 'UZBEKISTAN' | 'VANUATU' | 'VATICAN_CITY_STATE' | 'VENEZUELA' | 'VIET_NAM' | 'VIRGIN_ISLANDS_GB' | 'VIRGIN_ISLANDS_USA' | 'WALLIS_AND_FUTUNA' | 'WESTERN_SAHARA' | 'YEMEN' | 'ZAMBIA' | 'ZIMBABWE' | null
}
export type TransactionPropSourceDepositCountry$list = {
	[TransactionProp.SourceDepositCountry$list] : models.CollectionValueDto<null, models.CountryPayloadDto>[]
}
export type TransactionPropSourceError = {
	[TransactionProp.SourceError] : string | null
}
export type TransactionPropSourceExtAccountID = {
	[TransactionProp.SourceExtAccountID] : string | null
}
export type TransactionPropSourceExternalTransactionId = {
	[TransactionProp.SourceExternalTransactionId] : string | null
}
export type TransactionPropSourceFundMethodType = {
	[TransactionProp.SourceFundMethodType] : any /* Entity */
}
export type TransactionPropSourcePaymentMethodName = {
	[TransactionProp.SourcePaymentMethodName] : string | null
}
export type TransactionPropSourcePaymentProcessor = {
	[TransactionProp.SourcePaymentProcessor] : string | null
}
export type TransactionPropSourceSourceBankAccount = {
	[TransactionProp.SourceSourceBankAccount] : any /* Entity */
}
export type TransactionPropSourceSourceBankAccountId = {
	[TransactionProp.SourceSourceBankAccountId] : number | null
}
export type TransactionPropSourceStatus = {
	[TransactionProp.SourceStatus] : 'PENDING' | 'PROCESSING' | 'DONE' | 'FAILED' | null
}
export type TransactionPropSourceTargetBankAccount = {
	[TransactionProp.SourceTargetBankAccount] : any /* Entity */
}
export type TransactionPropSourceTargetBankAccountName = {
	[TransactionProp.SourceTargetBankAccountName] : string | null
}
export type TransactionPropSourceTraceId = {
	[TransactionProp.SourceTraceId] : string | null
}
export type TransactionPropStatus = {
	[TransactionProp.Status] : 'PENDING' | 'PENDING_COMPLIANCE' | 'DONE' | 'FAILED' | 'REJECTED' | 'PENDING_PM_APPROVAL' | 'CANCELLED_PENDING_PM_APPROVAL' | 'CANCELLED_PENDING_COMPLIANCE' | null
}
export type TransactionPropTargetAmount = {
	[TransactionProp.TargetAmount] : number | null
}
export type TransactionPropTargetAuthCode = {
	[TransactionProp.TargetAuthCode] : string | null
}
export type TransactionPropTargetCreditCardId = {
	[TransactionProp.TargetCreditCardId] : number | null
}
export type TransactionPropTargetCreditCardNumber = {
	[TransactionProp.TargetCreditCardNumber] : string | null
}
export type TransactionPropTargetCreditCardDeposit = {
	[TransactionProp.TargetCreditCardDeposit] : any /* Entity */
}
export type TransactionPropTargetCurrency = {
	[TransactionProp.TargetCurrency] : 'USD' | 'EUR' | 'GBP' | 'CAD' | 'JPY' | 'AED' | 'PLN' | 'AZN' | 'INR' | 'NZD' | 'CUP' | 'EGP' | 'LBP' | 'RMB' | 'AUD' | 'ILS' | 'RON' | 'CHF' | 'CZK' | 'DKK' | 'RUB' | 'BGN' | 'HRK' | 'CNY' | 'MXN' | 'CLP' | 'ALL' | 'NOK' | 'SEK' | 'HUF' | 'BRL' | 'ZAR' | 'HKD' | 'SGD' | 'THB' | 'TRY' | 'KRW' | 'SKK' | 'LKR' | 'COP' | 'VND' | 'CNH' | 'SAR' | 'MYR' | 'USDT' | 'LOCAL_CURRENCY' | null
}
export type TransactionPropTargetError = {
	[TransactionProp.TargetError] : string | null
}
export type TransactionPropTargetExtAccountID = {
	[TransactionProp.TargetExtAccountID] : string | null
}
export type TransactionPropTargetExternalTransactionDetails = {
	[TransactionProp.TargetExternalTransactionDetails] : string | null
}
export type TransactionPropTargetExternalTransactionId = {
	[TransactionProp.TargetExternalTransactionId] : string | null
}
export type TransactionPropTargetSourceBankAccountName = {
	[TransactionProp.TargetSourceBankAccountName] : string | null
}
export type TransactionPropTargetStatus = {
	[TransactionProp.TargetStatus] : 'PENDING' | 'PROCESSING' | 'DONE' | 'FAILED' | null
}
export type TransactionPropTargetTargetBankAccountId = {
	[TransactionProp.TargetTargetBankAccountId] : number | null
}
export type TransactionPropTargetTargetBankAccountName = {
	[TransactionProp.TargetTargetBankAccountName] : string | null
}
export type TransactionPropTargetCurrencyConvRate = {
	[TransactionProp.TargetCurrencyConvRate] : number | null
}
export type TransactionPropTradingAccountId = {
	[TransactionProp.TradingAccountId] : number | null
}
export type TransactionPropTradingAccountId$name = {
	[TransactionProp.TradingAccountId$name] : number | null
}
export type TransactionPropTransactionKind = {
	[TransactionProp.TransactionKind] : 'NEGATIVE_ADJUSTMENT' | 'NEGATIVE_DEALING_CORRECTION' | 'NEGATIVE_FRAUD_ADJUSTMENT' | 'NEGATIVE_BONUS_ADJUSTMENT' | 'CLOSING_ACCOUNT_BOOK_NEGATIVE' | 'PARTNER_NEGATIVE_ADJUSTMENT' | 'POSITIVE_ADJUSTMENT' | 'POSITIVE_DEALING_CORRECTION' | 'POSITIVE_FRAUD_ADJUSTMENT' | 'POSITIVE_BONUS_ADJUSTMENT' | 'CLOSING_ACCOUNT_BOOK_POSITIVE' | 'PARTNER_PAYMENT' | 'PARTNER_BONUS' | 'BONUS' | 'CREDIT_CARD_DEPOSIT' | 'WIRE_TRANSFER_DEPOSIT' | 'CREDIT_CREDIT_CARD_WITHDRAWAL' | 'VOID_CREDIT_CARD_WITHDRAWAL' | 'REFUND_CREDIT_CARD_WITHDRAWAL' | 'WIRE_TRANSFER_WITHDRAWAL' | 'MANUAL_DEPOSIT' | 'INTERNAL_DEPOSIT' | 'MANUAL_WITHDRAWAL' | 'INTERNAL_WITHDRAWAL' | 'LIBERTY_RESERVE_DEPOSIT' | 'LIBERTY_RESERVE_WITHDRAWAL' | 'ENVOY_DEPOSIT' | 'ENVOY_WITHDRAWAL' | 'WM_WITHDRAWAL' | 'NETELLER_DEPOSIT' | 'MONEYBOOKERS_DEPOSIT' | 'QIWI_DEPOSIT' | 'WEBMONEY_DEPOSIT' | 'CHINAUNION_DEPOSIT' | 'CUP_DEPOSIT' | 'CHINAUNION_WITHDRAWAL' | 'LOBANET_DEPOSIT' | 'QIWI_WITHDRAWAL' | 'PSP_DEPOSIT' | 'BAOFOO_DEPOSIT' | 'SOLIDPAY_DEPOSIT' | 'FOCAL_DEPOSIT' | 'PAYGATE_DEPOSIT' | 'PAYMENT_ASIA_DEPOSIT' | 'CRYPTO_WITHDRAWAL' | 'MD_APM_WITHDRAWAL' | null
}
export type TransactionPropTransactionType = {
	[TransactionProp.TransactionType] : 'DEPOSIT' | 'WITHDRAWAL' | 'CORRECTION' | null
}
export type TransactionPropTxSubType = {
	[TransactionProp.TxSubType] : 'NEGATIVE_ADJUSTMENT' | 'NEGATIVE_DEALING_CORRECTION' | 'NEGATIVE_FRAUD_ADJUSTMENT' | 'NEGATIVE_BONUS_ADJUSTMENT' | 'CLOSING_ACCOUNT_BOOK_NEGATIVE' | 'PARTNER_NEGATIVE_ADJUSTMENT' | 'POSITIVE_ADJUSTMENT' | 'POSITIVE_DEALING_CORRECTION' | 'POSITIVE_FRAUD_ADJUSTMENT' | 'POSITIVE_BONUS_ADJUSTMENT' | 'CLOSING_ACCOUNT_BOOK_POSITIVE' | 'PARTNER_PAYMENT' | 'PARTNER_BONUS' | 'BONUS' | 'CREDIT_CARD_DEPOSIT' | 'WIRE_TRANSFER_DEPOSIT' | 'CREDIT_CREDIT_CARD_WITHDRAWAL' | 'VOID_CREDIT_CARD_WITHDRAWAL' | 'REFUND_CREDIT_CARD_WITHDRAWAL' | 'WIRE_TRANSFER_WITHDRAWAL' | 'MANUAL_DEPOSIT' | 'INTERNAL_DEPOSIT' | 'MANUAL_WITHDRAWAL' | 'INTERNAL_WITHDRAWAL' | 'LIBERTY_RESERVE_DEPOSIT' | 'LIBERTY_RESERVE_WITHDRAWAL' | 'ENVOY_DEPOSIT' | 'ENVOY_WITHDRAWAL' | 'WM_WITHDRAWAL' | 'NETELLER_DEPOSIT' | 'MONEYBOOKERS_DEPOSIT' | 'QIWI_DEPOSIT' | 'WEBMONEY_DEPOSIT' | 'CHINAUNION_DEPOSIT' | 'CUP_DEPOSIT' | 'CHINAUNION_WITHDRAWAL' | 'LOBANET_DEPOSIT' | 'QIWI_WITHDRAWAL' | 'PSP_DEPOSIT' | 'BAOFOO_DEPOSIT' | 'SOLIDPAY_DEPOSIT' | 'FOCAL_DEPOSIT' | 'PAYGATE_DEPOSIT' | 'PAYMENT_ASIA_DEPOSIT' | 'CRYPTO_WITHDRAWAL' | 'MD_APM_WITHDRAWAL' | null
}
export type TransactionPropWithdrawalRequestId = {
	[TransactionProp.WithdrawalRequestId] : number | null
}
export type TransactionPropWithdrawalRequestRequestedAmount = {
	[TransactionProp.WithdrawalRequestRequestedAmount] : string | null
}
export type TransactionPropWithdrawalRequestRequestedCurrency = {
	[TransactionProp.WithdrawalRequestRequestedCurrency] : string | null
}


export type Transaction = 
	TransactionPropAuth3D & 
	TransactionPropAvailableReason & 
	TransactionPropCanceledByTransaction & 
	TransactionPropCancelsTransaction & 
	TransactionPropCcNumber & 
	TransactionPropCreationTime & 
	TransactionPropCustomerBrandName & 
	TransactionPropCustomerComplianceDataAllowDeposits & 
	TransactionPropCustomerId & 
	TransactionPropCustomerPersonFirstName & 
	TransactionPropCustomerPersonLastName & 
	TransactionPropCustomerPersonName & 
	TransactionPropDepositDate & 
	TransactionPropDescription & 
	TransactionPropEcdd & 
	TransactionPropExternalId & 
	TransactionPropId & 
	TransactionPropModificationTime & 
	TransactionPropModifiedBy & 
	TransactionPropPaymentDate & 
	TransactionPropPermanentUser & 
	TransactionPropReasonCustomerReason & 
	TransactionPropReasonInternalReason & 
	TransactionPropRefundedAmount & 
	TransactionPropRejectionReason & 
	TransactionPropRelatedBonus & 
	TransactionPropRelatedInternalTransactionId & 
	TransactionPropSasReportExcluded & 
	TransactionPropSource$sourceBankAccountName & 
	TransactionPropSourceAmount & 
	TransactionPropSourceApmExternalTransactionId & 
	TransactionPropSourceCreditCardId & 
	TransactionPropSourceCurrency & 
	TransactionPropSourceDepositCountry & 
	TransactionPropSourceDepositCountry$list & 
	TransactionPropSourceError & 
	TransactionPropSourceExtAccountID & 
	TransactionPropSourceExternalTransactionId & 
	TransactionPropSourceFundMethodType & 
	TransactionPropSourcePaymentMethodName & 
	TransactionPropSourcePaymentProcessor & 
	TransactionPropSourceSourceBankAccount & 
	TransactionPropSourceSourceBankAccountId & 
	TransactionPropSourceStatus & 
	TransactionPropSourceTargetBankAccount & 
	TransactionPropSourceTargetBankAccountName & 
	TransactionPropSourceTraceId & 
	TransactionPropStatus & 
	TransactionPropTargetAmount & 
	TransactionPropTargetAuthCode & 
	TransactionPropTargetCreditCardId & 
	TransactionPropTargetCreditCardNumber & 
	TransactionPropTargetCreditCardDeposit & 
	TransactionPropTargetCurrency & 
	TransactionPropTargetError & 
	TransactionPropTargetExtAccountID & 
	TransactionPropTargetExternalTransactionDetails & 
	TransactionPropTargetExternalTransactionId & 
	TransactionPropTargetSourceBankAccountName & 
	TransactionPropTargetStatus & 
	TransactionPropTargetTargetBankAccountId & 
	TransactionPropTargetTargetBankAccountName & 
	TransactionPropTargetCurrencyConvRate & 
	TransactionPropTradingAccountId & 
	TransactionPropTradingAccountId$name & 
	TransactionPropTransactionKind & 
	TransactionPropTransactionType & 
	TransactionPropTxSubType & 
	TransactionPropWithdrawalRequestId & 
	TransactionPropWithdrawalRequestRequestedAmount & 
	TransactionPropWithdrawalRequestRequestedCurrency

export const TRANSACTION_PROPERTY_NAMES = Object.freeze([TransactionProp.Auth3D, TransactionProp.AvailableReason, TransactionProp.CanceledByTransaction, TransactionProp.CancelsTransaction, TransactionProp.CcNumber, TransactionProp.CreationTime, TransactionProp.CustomerBrandName, TransactionProp.CustomerComplianceDataAllowDeposits, TransactionProp.CustomerId, TransactionProp.CustomerPersonFirstName, TransactionProp.CustomerPersonLastName, TransactionProp.CustomerPersonName, TransactionProp.DepositDate, TransactionProp.Description, TransactionProp.Ecdd, TransactionProp.ExternalId, TransactionProp.Id, TransactionProp.ModificationTime, TransactionProp.ModifiedBy, TransactionProp.PaymentDate, TransactionProp.PermanentUser, TransactionProp.ReasonCustomerReason, TransactionProp.ReasonInternalReason, TransactionProp.RefundedAmount, TransactionProp.RejectionReason, TransactionProp.RelatedBonus, TransactionProp.RelatedInternalTransactionId, TransactionProp.SasReportExcluded, TransactionProp.Source$sourceBankAccountName, TransactionProp.SourceAmount, TransactionProp.SourceApmExternalTransactionId, TransactionProp.SourceCreditCardId, TransactionProp.SourceCurrency, TransactionProp.SourceDepositCountry, TransactionProp.SourceDepositCountry$list, TransactionProp.SourceError, TransactionProp.SourceExtAccountID, TransactionProp.SourceExternalTransactionId, TransactionProp.SourceFundMethodType, TransactionProp.SourcePaymentMethodName, TransactionProp.SourcePaymentProcessor, TransactionProp.SourceSourceBankAccount, TransactionProp.SourceSourceBankAccountId, TransactionProp.SourceStatus, TransactionProp.SourceTargetBankAccount, TransactionProp.SourceTargetBankAccountName, TransactionProp.SourceTraceId, TransactionProp.Status, TransactionProp.TargetAmount, TransactionProp.TargetAuthCode, TransactionProp.TargetCreditCardId, TransactionProp.TargetCreditCardNumber, TransactionProp.TargetCreditCardDeposit, TransactionProp.TargetCurrency, TransactionProp.TargetError, TransactionProp.TargetExtAccountID, TransactionProp.TargetExternalTransactionDetails, TransactionProp.TargetExternalTransactionId, TransactionProp.TargetSourceBankAccountName, TransactionProp.TargetStatus, TransactionProp.TargetTargetBankAccountId, TransactionProp.TargetTargetBankAccountName, TransactionProp.TargetCurrencyConvRate, TransactionProp.TradingAccountId, TransactionProp.TradingAccountId$name, TransactionProp.TransactionKind, TransactionProp.TransactionType, TransactionProp.TxSubType, TransactionProp.WithdrawalRequestId, TransactionProp.WithdrawalRequestRequestedAmount, TransactionProp.WithdrawalRequestRequestedCurrency])

export type TransactionTab = 
	TransactionPropId & 
	TransactionPropCustomerId & 
	TransactionPropCustomerPersonFirstName & 
	TransactionPropCustomerPersonLastName & 
	TransactionPropTxSubType

export const TRANSACTION_TAB_PROPERTY_NAMES = Object.freeze([TransactionProp.Id, TransactionProp.CustomerId, TransactionProp.CustomerPersonFirstName, TransactionProp.CustomerPersonLastName, TransactionProp.TxSubType])

export type TransactionHistoryTab = 
	TransactionPropId & 
	TransactionPropCustomerId & 
	TransactionPropCustomerPersonFirstName & 
	TransactionPropCustomerPersonLastName & 
	TransactionPropTxSubType

export const TRANSACTION_HISTORY_TAB_PROPERTY_NAMES = Object.freeze([TransactionProp.Id, TransactionProp.CustomerId, TransactionProp.CustomerPersonFirstName, TransactionProp.CustomerPersonLastName, TransactionProp.TxSubType])

export type TransactionHeader = 
	TransactionPropId & 
	TransactionPropTxSubType & 
	TransactionPropTransactionKind & 
	TransactionPropTransactionType & 
	TransactionPropReasonInternalReason & 
	TransactionPropTargetCurrency & 
	TransactionPropTargetAmount & 
	TransactionPropCustomerPersonName & 
	TransactionPropTradingAccountId & 
	TransactionPropTradingAccountId$name

export const TRANSACTION_HEADER_PROPERTY_NAMES = Object.freeze([TransactionProp.Id, TransactionProp.TxSubType, TransactionProp.TransactionKind, TransactionProp.TransactionType, TransactionProp.ReasonInternalReason, TransactionProp.TargetCurrency, TransactionProp.TargetAmount, TransactionProp.CustomerPersonName, TransactionProp.TradingAccountId, TransactionProp.TradingAccountId$name])

export type TransactionInformation = 
	TransactionPropId & 
	TransactionPropCreationTime & 
	TransactionPropModificationTime & 
	TransactionPropModifiedBy & 
	TransactionPropTradingAccountId & 
	TransactionPropTradingAccountId$name & 
	TransactionPropTxSubType & 
	TransactionPropCustomerId & 
	TransactionPropCustomerPersonName & 
	TransactionPropCustomerBrandName & 
	TransactionPropStatus & 
	TransactionPropCancelsTransaction & 
	TransactionPropCanceledByTransaction & 
	TransactionPropSourceStatus & 
	TransactionPropTargetStatus & 
	TransactionPropSourceError & 
	TransactionPropTargetError & 
	TransactionPropPermanentUser & 
	TransactionPropSasReportExcluded & 
	TransactionPropPaymentDate

export const TRANSACTION_INFORMATION_PROPERTY_NAMES = Object.freeze([TransactionProp.Id, TransactionProp.CreationTime, TransactionProp.ModificationTime, TransactionProp.ModifiedBy, TransactionProp.TradingAccountId, TransactionProp.TradingAccountId$name, TransactionProp.TxSubType, TransactionProp.CustomerId, TransactionProp.CustomerPersonName, TransactionProp.CustomerBrandName, TransactionProp.Status, TransactionProp.CancelsTransaction, TransactionProp.CanceledByTransaction, TransactionProp.SourceStatus, TransactionProp.TargetStatus, TransactionProp.SourceError, TransactionProp.TargetError, TransactionProp.PermanentUser, TransactionProp.SasReportExcluded, TransactionProp.PaymentDate])

export type TransactionWithdrawalInformation = 
	TransactionPropId & 
	TransactionPropCreationTime & 
	TransactionPropModificationTime & 
	TransactionPropModifiedBy & 
	TransactionPropTradingAccountId & 
	TransactionPropTradingAccountId$name & 
	TransactionPropTxSubType & 
	TransactionPropCustomerId & 
	TransactionPropCustomerPersonName & 
	TransactionPropCustomerBrandName & 
	TransactionPropStatus & 
	TransactionPropCancelsTransaction & 
	TransactionPropCanceledByTransaction & 
	TransactionPropSourceStatus & 
	TransactionPropTargetStatus & 
	TransactionPropSourceError & 
	TransactionPropTargetError & 
	TransactionPropPermanentUser & 
	TransactionPropSasReportExcluded & 
	TransactionPropPaymentDate & 
	TransactionPropWithdrawalRequestId

export const TRANSACTION_WITHDRAWAL_INFORMATION_PROPERTY_NAMES = Object.freeze([TransactionProp.Id, TransactionProp.CreationTime, TransactionProp.ModificationTime, TransactionProp.ModifiedBy, TransactionProp.TradingAccountId, TransactionProp.TradingAccountId$name, TransactionProp.TxSubType, TransactionProp.CustomerId, TransactionProp.CustomerPersonName, TransactionProp.CustomerBrandName, TransactionProp.Status, TransactionProp.CancelsTransaction, TransactionProp.CanceledByTransaction, TransactionProp.SourceStatus, TransactionProp.TargetStatus, TransactionProp.SourceError, TransactionProp.TargetError, TransactionProp.PermanentUser, TransactionProp.SasReportExcluded, TransactionProp.PaymentDate, TransactionProp.WithdrawalRequestId])

export type TransactionDepositInformation = 
	TransactionPropId & 
	TransactionPropCreationTime & 
	TransactionPropModificationTime & 
	TransactionPropModifiedBy & 
	TransactionPropTradingAccountId & 
	TransactionPropTradingAccountId$name & 
	TransactionPropTxSubType & 
	TransactionPropCustomerId & 
	TransactionPropCustomerPersonName & 
	TransactionPropCustomerBrandName & 
	TransactionPropStatus & 
	TransactionPropCancelsTransaction & 
	TransactionPropCanceledByTransaction & 
	TransactionPropSourceStatus & 
	TransactionPropTargetStatus & 
	TransactionPropSourceError & 
	TransactionPropTargetError & 
	TransactionPropPermanentUser & 
	TransactionPropSasReportExcluded & 
	TransactionPropPaymentDate & 
	TransactionPropCustomerComplianceDataAllowDeposits & 
	TransactionPropSourceDepositCountry$list & 
	TransactionPropEcdd & 
	TransactionPropRejectionReason & 
	TransactionPropCustomerComplianceDataAllowDeposits & 
	TransactionPropSourceTraceId & 
	TransactionPropSourcePaymentProcessor & 
	TransactionPropSourcePaymentMethodName

export const TRANSACTION_DEPOSIT_INFORMATION_PROPERTY_NAMES = Object.freeze([TransactionProp.Id, TransactionProp.CreationTime, TransactionProp.ModificationTime, TransactionProp.ModifiedBy, TransactionProp.TradingAccountId, TransactionProp.TradingAccountId$name, TransactionProp.TxSubType, TransactionProp.CustomerId, TransactionProp.CustomerPersonName, TransactionProp.CustomerBrandName, TransactionProp.Status, TransactionProp.CancelsTransaction, TransactionProp.CanceledByTransaction, TransactionProp.SourceStatus, TransactionProp.TargetStatus, TransactionProp.SourceError, TransactionProp.TargetError, TransactionProp.PermanentUser, TransactionProp.SasReportExcluded, TransactionProp.PaymentDate, TransactionProp.CustomerComplianceDataAllowDeposits, TransactionProp.SourceDepositCountry$list, TransactionProp.Ecdd, TransactionProp.RejectionReason, TransactionProp.CustomerComplianceDataAllowDeposits, TransactionProp.SourceTraceId, TransactionProp.SourcePaymentProcessor, TransactionProp.SourcePaymentMethodName])

export type TransactionWTInformation = 
	TransactionPropId & 
	TransactionPropCreationTime & 
	TransactionPropModificationTime & 
	TransactionPropModifiedBy & 
	TransactionPropTradingAccountId & 
	TransactionPropTradingAccountId$name & 
	TransactionPropTxSubType & 
	TransactionPropCustomerId & 
	TransactionPropCustomerPersonName & 
	TransactionPropCustomerBrandName & 
	TransactionPropStatus & 
	TransactionPropCancelsTransaction & 
	TransactionPropCanceledByTransaction & 
	TransactionPropSourceStatus & 
	TransactionPropTargetStatus & 
	TransactionPropSourceError & 
	TransactionPropTargetError & 
	TransactionPropPermanentUser & 
	TransactionPropSasReportExcluded & 
	TransactionPropPaymentDate & 
	TransactionPropEcdd & 
	TransactionPropSource$sourceBankAccountName & 
	TransactionPropSourceTargetBankAccountName & 
	TransactionPropSourceSourceBankAccountId & 
	TransactionPropSourceExternalTransactionId & 
	TransactionPropDepositDate

export const TRANSACTION_W_T_INFORMATION_PROPERTY_NAMES = Object.freeze([TransactionProp.Id, TransactionProp.CreationTime, TransactionProp.ModificationTime, TransactionProp.ModifiedBy, TransactionProp.TradingAccountId, TransactionProp.TradingAccountId$name, TransactionProp.TxSubType, TransactionProp.CustomerId, TransactionProp.CustomerPersonName, TransactionProp.CustomerBrandName, TransactionProp.Status, TransactionProp.CancelsTransaction, TransactionProp.CanceledByTransaction, TransactionProp.SourceStatus, TransactionProp.TargetStatus, TransactionProp.SourceError, TransactionProp.TargetError, TransactionProp.PermanentUser, TransactionProp.SasReportExcluded, TransactionProp.PaymentDate, TransactionProp.Ecdd, TransactionProp.Source$sourceBankAccountName, TransactionProp.SourceTargetBankAccountName, TransactionProp.SourceSourceBankAccountId, TransactionProp.SourceExternalTransactionId, TransactionProp.DepositDate])

export type TransactionWTWithdrawalInformation = 
	TransactionPropId & 
	TransactionPropCreationTime & 
	TransactionPropModificationTime & 
	TransactionPropModifiedBy & 
	TransactionPropTradingAccountId & 
	TransactionPropTradingAccountId$name & 
	TransactionPropTxSubType & 
	TransactionPropCustomerId & 
	TransactionPropCustomerPersonName & 
	TransactionPropCustomerBrandName & 
	TransactionPropStatus & 
	TransactionPropCancelsTransaction & 
	TransactionPropCanceledByTransaction & 
	TransactionPropSourceStatus & 
	TransactionPropTargetStatus & 
	TransactionPropSourceError & 
	TransactionPropTargetError & 
	TransactionPropPermanentUser & 
	TransactionPropSasReportExcluded & 
	TransactionPropPaymentDate & 
	TransactionPropWithdrawalRequestId & 
	TransactionPropTargetExternalTransactionId & 
	TransactionPropTargetSourceBankAccountName & 
	TransactionPropTargetTargetBankAccountId & 
	TransactionPropTargetTargetBankAccountName & 
	TransactionPropWithdrawalRequestRequestedAmount & 
	TransactionPropWithdrawalRequestRequestedCurrency

export const TRANSACTION_W_T_WITHDRAWAL_INFORMATION_PROPERTY_NAMES = Object.freeze([TransactionProp.Id, TransactionProp.CreationTime, TransactionProp.ModificationTime, TransactionProp.ModifiedBy, TransactionProp.TradingAccountId, TransactionProp.TradingAccountId$name, TransactionProp.TxSubType, TransactionProp.CustomerId, TransactionProp.CustomerPersonName, TransactionProp.CustomerBrandName, TransactionProp.Status, TransactionProp.CancelsTransaction, TransactionProp.CanceledByTransaction, TransactionProp.SourceStatus, TransactionProp.TargetStatus, TransactionProp.SourceError, TransactionProp.TargetError, TransactionProp.PermanentUser, TransactionProp.SasReportExcluded, TransactionProp.PaymentDate, TransactionProp.WithdrawalRequestId, TransactionProp.TargetExternalTransactionId, TransactionProp.TargetSourceBankAccountName, TransactionProp.TargetTargetBankAccountId, TransactionProp.TargetTargetBankAccountName, TransactionProp.WithdrawalRequestRequestedAmount, TransactionProp.WithdrawalRequestRequestedCurrency])

export type TransactionNegativeBonusAdjustmentInformation = 
	TransactionPropId & 
	TransactionPropCreationTime & 
	TransactionPropModificationTime & 
	TransactionPropModifiedBy & 
	TransactionPropTradingAccountId & 
	TransactionPropTradingAccountId$name & 
	TransactionPropTxSubType & 
	TransactionPropCustomerId & 
	TransactionPropCustomerPersonName & 
	TransactionPropCustomerBrandName & 
	TransactionPropStatus & 
	TransactionPropCancelsTransaction & 
	TransactionPropCanceledByTransaction & 
	TransactionPropSourceStatus & 
	TransactionPropTargetStatus & 
	TransactionPropSourceError & 
	TransactionPropTargetError & 
	TransactionPropPermanentUser & 
	TransactionPropSasReportExcluded & 
	TransactionPropPaymentDate & 
	TransactionPropRelatedBonus

export const TRANSACTION_NEGATIVE_BONUS_ADJUSTMENT_INFORMATION_PROPERTY_NAMES = Object.freeze([TransactionProp.Id, TransactionProp.CreationTime, TransactionProp.ModificationTime, TransactionProp.ModifiedBy, TransactionProp.TradingAccountId, TransactionProp.TradingAccountId$name, TransactionProp.TxSubType, TransactionProp.CustomerId, TransactionProp.CustomerPersonName, TransactionProp.CustomerBrandName, TransactionProp.Status, TransactionProp.CancelsTransaction, TransactionProp.CanceledByTransaction, TransactionProp.SourceStatus, TransactionProp.TargetStatus, TransactionProp.SourceError, TransactionProp.TargetError, TransactionProp.PermanentUser, TransactionProp.SasReportExcluded, TransactionProp.PaymentDate, TransactionProp.RelatedBonus])

export type TransactionCCWithdrawalInformation = 
	TransactionPropId & 
	TransactionPropCreationTime & 
	TransactionPropModificationTime & 
	TransactionPropModifiedBy & 
	TransactionPropTradingAccountId & 
	TransactionPropTradingAccountId$name & 
	TransactionPropTxSubType & 
	TransactionPropCustomerId & 
	TransactionPropCustomerPersonName & 
	TransactionPropCustomerBrandName & 
	TransactionPropStatus & 
	TransactionPropCancelsTransaction & 
	TransactionPropCanceledByTransaction & 
	TransactionPropSourceStatus & 
	TransactionPropTargetStatus & 
	TransactionPropSourceError & 
	TransactionPropTargetError & 
	TransactionPropPermanentUser & 
	TransactionPropSasReportExcluded & 
	TransactionPropPaymentDate & 
	TransactionPropWithdrawalRequestId & 
	TransactionPropTargetExternalTransactionId & 
	TransactionPropTargetAuthCode & 
	TransactionPropTargetExternalTransactionDetails

export const TRANSACTION_C_C_WITHDRAWAL_INFORMATION_PROPERTY_NAMES = Object.freeze([TransactionProp.Id, TransactionProp.CreationTime, TransactionProp.ModificationTime, TransactionProp.ModifiedBy, TransactionProp.TradingAccountId, TransactionProp.TradingAccountId$name, TransactionProp.TxSubType, TransactionProp.CustomerId, TransactionProp.CustomerPersonName, TransactionProp.CustomerBrandName, TransactionProp.Status, TransactionProp.CancelsTransaction, TransactionProp.CanceledByTransaction, TransactionProp.SourceStatus, TransactionProp.TargetStatus, TransactionProp.SourceError, TransactionProp.TargetError, TransactionProp.PermanentUser, TransactionProp.SasReportExcluded, TransactionProp.PaymentDate, TransactionProp.WithdrawalRequestId, TransactionProp.TargetExternalTransactionId, TransactionProp.TargetAuthCode, TransactionProp.TargetExternalTransactionDetails])

export type TransactionDetails = 
	TransactionPropReasonInternalReason & 
	TransactionPropDescription

export const TRANSACTION_DETAILS_PROPERTY_NAMES = Object.freeze([TransactionProp.ReasonInternalReason, TransactionProp.Description])

export type TransactionPSPDepositDetails = 
	TransactionPropReasonInternalReason & 
	TransactionPropDescription & 
	TransactionPropReasonCustomerReason & 
	TransactionPropSourceExternalTransactionId & 
	TransactionPropSourceExtAccountID & 
	TransactionPropSourceApmExternalTransactionId

export const TRANSACTION_P_S_P_DEPOSIT_DETAILS_PROPERTY_NAMES = Object.freeze([TransactionProp.ReasonInternalReason, TransactionProp.Description, TransactionProp.ReasonCustomerReason, TransactionProp.SourceExternalTransactionId, TransactionProp.SourceExtAccountID, TransactionProp.SourceApmExternalTransactionId])

export type TransactionCCDepositDetails = 
	TransactionPropReasonInternalReason & 
	TransactionPropDescription & 
	TransactionPropExternalId & 
	TransactionPropReasonCustomerReason & 
	TransactionPropAuth3D

export const TRANSACTION_C_C_DEPOSIT_DETAILS_PROPERTY_NAMES = Object.freeze([TransactionProp.ReasonInternalReason, TransactionProp.Description, TransactionProp.ExternalId, TransactionProp.ReasonCustomerReason, TransactionProp.Auth3D])

export type TransactionManualWithdrawalDetails = 
	TransactionPropReasonInternalReason & 
	TransactionPropDescription & 
	TransactionPropTargetExternalTransactionId & 
	TransactionPropRelatedInternalTransactionId & 
	TransactionPropTargetExtAccountID

export const TRANSACTION_MANUAL_WITHDRAWAL_DETAILS_PROPERTY_NAMES = Object.freeze([TransactionProp.ReasonInternalReason, TransactionProp.Description, TransactionProp.TargetExternalTransactionId, TransactionProp.RelatedInternalTransactionId, TransactionProp.TargetExtAccountID])

export type TransactionManualDepositDetails = 
	TransactionPropReasonInternalReason & 
	TransactionPropDescription & 
	TransactionPropSourceExtAccountID & 
	TransactionPropSourceExternalTransactionId & 
	TransactionPropRelatedInternalTransactionId

export const TRANSACTION_MANUAL_DEPOSIT_DETAILS_PROPERTY_NAMES = Object.freeze([TransactionProp.ReasonInternalReason, TransactionProp.Description, TransactionProp.SourceExtAccountID, TransactionProp.SourceExternalTransactionId, TransactionProp.RelatedInternalTransactionId])

export type TransactionAmount = 
	TransactionPropTargetAmount & 
	TransactionPropTargetCurrency & 
	TransactionPropSourceCurrency & 
	TransactionPropSourceAmount & 
	TransactionPropTargetCurrencyConvRate

export const TRANSACTION_AMOUNT_PROPERTY_NAMES = Object.freeze([TransactionProp.TargetAmount, TransactionProp.TargetCurrency, TransactionProp.SourceCurrency, TransactionProp.SourceAmount, TransactionProp.TargetCurrencyConvRate])

export type TransactionCCDepositAmount = 
	TransactionPropTargetAmount & 
	TransactionPropTargetCurrency & 
	TransactionPropSourceCurrency & 
	TransactionPropSourceAmount & 
	TransactionPropTargetCurrencyConvRate & 
	TransactionPropSourceCreditCardId & 
	TransactionPropCcNumber & 
	TransactionPropRefundedAmount

export const TRANSACTION_C_C_DEPOSIT_AMOUNT_PROPERTY_NAMES = Object.freeze([TransactionProp.TargetAmount, TransactionProp.TargetCurrency, TransactionProp.SourceCurrency, TransactionProp.SourceAmount, TransactionProp.TargetCurrencyConvRate, TransactionProp.SourceCreditCardId, TransactionProp.CcNumber, TransactionProp.RefundedAmount])

export type TransactionCCWithdrawalAmount = 
	TransactionPropTargetAmount & 
	TransactionPropTargetCurrency & 
	TransactionPropSourceCurrency & 
	TransactionPropSourceAmount & 
	TransactionPropTargetCurrencyConvRate & 
	TransactionPropTargetCreditCardId & 
	TransactionPropTargetCreditCardNumber

export const TRANSACTION_C_C_WITHDRAWAL_AMOUNT_PROPERTY_NAMES = Object.freeze([TransactionProp.TargetAmount, TransactionProp.TargetCurrency, TransactionProp.SourceCurrency, TransactionProp.SourceAmount, TransactionProp.TargetCurrencyConvRate, TransactionProp.TargetCreditCardId, TransactionProp.TargetCreditCardNumber])

export type TransactionRefundCCWithdrawalAmount = 
	TransactionPropTargetAmount & 
	TransactionPropTargetCurrency & 
	TransactionPropSourceCurrency & 
	TransactionPropSourceAmount & 
	TransactionPropTargetCurrencyConvRate & 
	TransactionPropTargetCreditCardDeposit

export const TRANSACTION_REFUND_C_C_WITHDRAWAL_AMOUNT_PROPERTY_NAMES = Object.freeze([TransactionProp.TargetAmount, TransactionProp.TargetCurrency, TransactionProp.SourceCurrency, TransactionProp.SourceAmount, TransactionProp.TargetCurrencyConvRate, TransactionProp.TargetCreditCardDeposit])

export type TransactionCreate = 
	TransactionPropCustomerId & 
	TransactionPropTradingAccountId & 
	TransactionPropAvailableReason & 
	TransactionPropSourceSourceBankAccount & 
	TransactionPropSourceTargetBankAccount & 
	TransactionPropDescription & 
	TransactionPropTargetAmount & 
	TransactionPropTargetCurrency & 
	TransactionPropSourceCurrency & 
	TransactionPropSourceAmount & 
	TransactionPropTargetCurrencyConvRate & 
	TransactionPropDepositDate & 
	TransactionPropSourceExternalTransactionId & 
	TransactionPropSourceFundMethodType & 
	TransactionPropSourceExtAccountID & 
	TransactionPropSourceDepositCountry & 
	TransactionPropRelatedInternalTransactionId

export const TRANSACTION_CREATE_PROPERTY_NAMES = Object.freeze([TransactionProp.CustomerId, TransactionProp.TradingAccountId, TransactionProp.AvailableReason, TransactionProp.SourceSourceBankAccount, TransactionProp.SourceTargetBankAccount, TransactionProp.Description, TransactionProp.TargetAmount, TransactionProp.TargetCurrency, TransactionProp.SourceCurrency, TransactionProp.SourceAmount, TransactionProp.TargetCurrencyConvRate, TransactionProp.DepositDate, TransactionProp.SourceExternalTransactionId, TransactionProp.SourceFundMethodType, TransactionProp.SourceExtAccountID, TransactionProp.SourceDepositCountry, TransactionProp.RelatedInternalTransactionId])
